import React from 'react';
import PropTypes from 'prop-types';

import Button from '@marvelapp/marvel-ui/button';
import { MARVELAPP_PROJECTS } from 'marketing-website/constants/urls';

import styles from './style/welcome.module.css';

export default class WelcomeMessage extends React.Component {
  state = {
    isLoading: false,
  };

  toggleLoadingState = () => {
    this.setState({ isLoading: !this.state.isLoading });
  };

  onClick = () => {
    this.toggleLoadingState();
    window.location.href = MARVELAPP_PROJECTS;
  };

  render() {
    const style = {
      paddingRight: this.state.isLoading ? 170 : 155,
    };
    return (
      <div className={styles.pill} style={style}>
        <div className={styles.truncate}>
          Welcome back{this.props.username && `, ${this.props.username}`}
        </div>
        <div className={styles.absolute}>
          <Button
            background="blue"
            color="white"
            isLoading={this.state.isLoading}
            onClick={this.onClick}
            shape="rounded"
          >
            Go to dashboard
          </Button>
        </div>
      </div>
    );
  }
}

WelcomeMessage.propTypes = {
  username: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/modules/WelcomeMessage/index.js